import { CURRENT_LANGUAGE, DEFAULT_LANGUAGE } from "~/utils/constants";
import { invalidateNavigationCache } from "~/features/navigation/redux/navigationThunks";

function getCurrentLanguage(availableLanguages: string[]) {
  return availableLanguages.includes(CURRENT_LANGUAGE) ? CURRENT_LANGUAGE : DEFAULT_LANGUAGE;
}

async function changeLanguage(code: string) {
  invalidateNavigationCache();

  const url = new URL(window.location.href);
  const contextPath = window.__SCHA_BOOT__?.contextPath === "/" ? "" : window.__SCHA_BOOT__?.contextPath ?? "";

  if (contextPath && (url.pathname === contextPath || url.pathname.startsWith(`${contextPath}/`))) {
    const nextContextPath = contextPath
      .split("/")
      .map((segment) => (segment === CURRENT_LANGUAGE ? code : segment))
      .join("/");
    url.pathname = `${nextContextPath}${url.pathname.slice(contextPath.length)}`;
    url.searchParams.delete("lang");
  } else {
    url.searchParams.set("lang", code);
  }

  window.location.assign(url.toString());
}

export const LanguageService = {
  getCurrentLanguage,
  changeLanguage,
};
